// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"e8fb59a2","751":"1ab0a68e"}[chunkId] + ".chunk.css";
};